import './App.css';
import {HashRouter, Route, Routes} from "react-router-dom";
import {PRODUCT_IS_PUBLIC, routers} from "./routers/routerConfig";
import {ConfigProvider} from "antd";
import zhCN from 'antd/lib/locale/zh_CN';

function App() {

    const tiledConfig = (items) => {
        let result = []
        for (let i = 0; i < items.length; i++) {
            const item = items[i]
            if (item.children) {
                const sub = tiledConfig(item.children)
                result = [...result, ...sub]
            } else {
                result = [...result, item]
            }
        }
        return result
    }

    const renderTemplate = (template) => {
        const result = tiledConfig(template.children)
        const routers = result.filter(item => {
            if (PRODUCT_IS_PUBLIC && !item.isPublic) return false
            if (!PRODUCT_IS_PUBLIC && !item.isPrivate) return false
            return true
        })
        return <Route path={template.path} element={template.component}>
            {routers.map(item => <Route path={item.path} element={item.component}/>)}
        </Route>
    }

    return (
        <ConfigProvider locale={zhCN}>
            <HashRouter>
                <Routes>

                    {
                        routers.map(renderTemplate)
                    }

                </Routes>
            </HashRouter>
        </ConfigProvider>
    );
}

export default App;
